// Base container row for permissions
import { Icon } from 'antd';
import { Text } from 'common-components/typography';
import { HyperlinkButton } from 'common-components/buttons';
import React from 'react';
import { SubscriptionPermissionType } from 'utilities/enum-utils';

interface IPermissionRowBaseProps {
  actionsDisabled: boolean;
  iconName: string;
  title: string;
  description: string;
  currentFlag: string;
  isTargetUserPrimaryOwner?: boolean;
  onClickModify: () => void;
}

export function PermissionRowBase({
  iconName,
  title,
  description,
  currentFlag,
  actionsDisabled,
  isTargetUserPrimaryOwner,
  onClickModify,
}: IPermissionRowBaseProps) {
  return (
    <div className="flex-row" style={{ maxWidth: '90%' }}>
      <div className="mr-large pv-medium flex-column justify-start">
        <div className="mt-x-small">
          <Icon type={iconName} className="text-size-x2-large" />
        </div>
      </div>

      <div className="bordered-top flex-1 pv-medium align-start flex-row justify-between">
        {/* Title/description Container */}
        <div>
          <div>
            <Text lineHeight={100} size="x-large">
              {title}
            </Text>
          </div>

          <Text size="regular" color="secondary" lineHeight={100}>
            {description}
          </Text>
        </div>

        {/* Permission + Action Container */}
        <div className="flex-row">
          <div className="mr-large">
            <Text size="large">{isTargetUserPrimaryOwner ? 'Full access(Owner)' : currentFlag}</Text>
          </div>
          <div className="mr-large">
            {!actionsDisabled ? (
              <HyperlinkButton fontSize="large" onClick={onClickModify}>
                Modify
              </HyperlinkButton>
            ) : (
              <Text color="secondary">Default</Text>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
